export default __webpack_public_path__ + "static/media/image-study-admin-w@2x.33b8be33.webp";